import { useProject } from '@context/Project/ProjectProvider';
import {
  FilterAvailability,
  resolveFilterAvailability,
} from '@utils/filterAvailability';

/**
 * The filter funnel's state for the toolbar being rendered: the mode, which
 * view the route is on, which insight tab is open and whether the version
 * history is shown, read from the project context and resolved once per
 * render so the funnel, the chips and the separator agree.
 */
const useFilterAvailability = (): FilterAvailability => {
  const {
    toolbox: { mode },
    isDashboardMode,
    isInsightsMode,
    insightsTab,
    isVersionsShown,
  } = useProject();

  return resolveFilterAvailability({
    mode,
    isDashboardMode,
    isInsightsMode,
    insightsTab,
    isVersionsShown,
  });
};

export default useFilterAvailability;
